import { Component, OnInit } from '@angular/core';
import { CrawlerStatusService } from 'app/server/server.module';
import { Subscription } from 'rxjs';
import { UnsubscribeOnDestroy } from 'app/shared/decorators/unsubscribe-on-destroy';

interface SupplierNoDiscount {
  Name: string;
  Currency: string;
  Products: number;
  ProductsWithNoDiscountSet: number;
}

@Component({
  selector: 'app-discount-codes',
  templateUrl: './discount-codes.component.html',
  styleUrls: ['./discount-codes.component.scss']
})
export class DiscountCodesComponent implements OnInit {
  public discountCodes = 0;
  public discountCodesWithNoDiscountSet = 0;
  public products = 0;
  public productsWithNoDiscountSet = 0;
  public topSuppliers: SupplierNoDiscount[] = [];

  @UnsubscribeOnDestroy()
  private subscriptions: Subscription[] = [];

  constructor(private crawlerStatusService: CrawlerStatusService) { }

  ngOnInit(): void {
    this.subscriptions.push(this.crawlerStatusService.getDiscountCodes().subscribe((res: any) => {
      // Expecting the server response to contain the following shape:
      // { DiscountCodes: number, DiscountCodesWithNoDiscountSet: number, Products: number, ProductsWithNoDiscountSet: number, Suppliers: Array }
      this.discountCodes = res.DiscountCodes || 0;
      this.discountCodesWithNoDiscountSet = res.DiscountCodesWithNoDiscountSet || 0;
      this.products = res.Products || 0;
      this.productsWithNoDiscountSet = res.ProductsWithNoDiscountSet || 0;
      this.topSuppliers = res.Top25Suppliers
    }));
  }

}
